/* Theoria Records: YouTube embeds in multicolumn sections become a clean thumbnail
   with a play button and a "Watch on YouTube" link. The real player loads on click.
   Paste normal YouTube embed codes into a column's Custom Liquid; this swaps them. */
(function () {
  var YT_LOGO = '<svg aria-hidden="true" width="22" height="16" viewBox="0 0 22 16"><rect width="22" height="16" rx="4" fill="#FF0000"/><path d="M9 4.5v7l6-3.5z" fill="#fff"/></svg>';
  function videoId(src) {
    var m = src && src.match(/youtube(?:-nocookie)?\.com\/embed\/([A-Za-z0-9_-]{6,})/);
    return m && m[1];
  }
  function swap(frame) {
    if (!frame || frame.tagName !== 'IFRAME' || frame.hasAttribute('data-tr-keep')) return;
    if (!frame.closest || !frame.closest('.multicolumn')) return;
    var id = videoId(frame.getAttribute('src'));
    if (!id) return;
    var label = frame.getAttribute('title') || 'video';
    var card = frame.closest('.multicolumn-card');
    var heading = card && card.querySelector('h3');
    if (heading) label = heading.textContent.trim();

    var wrap = document.createElement('div');
    wrap.className = 'tr-yt';

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'tr-yt__play';
    btn.setAttribute('aria-label', 'Play ' + label + ' video');
    var img = document.createElement('img');
    img.alt = '';
    img.loading = 'lazy';
    img.src = 'https://i.ytimg.com/vi/' + id + '/maxresdefault.jpg';
    img.addEventListener('load', function () {
      if (img.naturalWidth <= 120 && img.src.indexOf('hqdefault') === -1) img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    });
    img.addEventListener('error', function () {
      if (img.src.indexOf('hqdefault') === -1) img.src = 'https://i.ytimg.com/vi/' + id + '/hqdefault.jpg';
    });
    var icon = document.createElement('span');
    icon.className = 'tr-yt__icon';
    icon.setAttribute('aria-hidden', 'true');
    btn.appendChild(img);
    btn.appendChild(icon);

    var link = document.createElement('a');
    link.className = 'tr-yt__watch';
    link.href = 'https://www.youtube.com/watch?v=' + id;
    link.target = '_blank';
    link.rel = 'noopener';
    link.innerHTML = YT_LOGO + '<span>Watch on YouTube</span>';

    btn.addEventListener('click', function () {
      var player = document.createElement('iframe');
      player.setAttribute('data-tr-keep', '');
      player.className = 'tr-yt__frame';
      player.src = 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&rel=0&playsinline=1';
      player.title = label;
      player.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
      player.setAttribute('allowfullscreen', '');
      wrap.innerHTML = '';
      wrap.appendChild(player);
    });

    wrap.appendChild(btn);
    wrap.appendChild(link);
    frame.parentNode.replaceChild(wrap, frame);
  }
  function scan(node) {
    if (!node || node.nodeType !== 1) return;
    if (node.tagName === 'IFRAME') swap(node);
    else if (node.querySelectorAll) Array.prototype.forEach.call(node.querySelectorAll('iframe'), swap);
  }
  var obs = new MutationObserver(function (muts) {
    muts.forEach(function (m) { Array.prototype.forEach.call(m.addedNodes, scan); });
  });
  obs.observe(document.documentElement, { childList: true, subtree: true });
  document.addEventListener('DOMContentLoaded', function () { scan(document.body); });
  /* Theme editor re-renders sections; keep watching there. */
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
